import { connectNetwork } from 'lib/NetworkProvider'
import View from 'lib/View'
import moment from 'moment-with-locales-es6'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Button, Icon, Menu, Statistic, Dropdown, Modal, Image, Header } from 'semantic-ui-react'
import { WORKDAY_ACTIONS } from '../actions/workday'
import { get_section, routes, route_from } from '../lib/routes'
import { Default, Mobile } from '../lib/util'

moment.locale('it')

const {
    app,
    organizations,
    message,
    jobs,
    employees,
    machines,
    categories,
    corps,
    deposits,
    contracts,
    admin,
    employee,
    insertion,
    calendarView,
    dashboard,
    stock,
    products,
    documents,
    dataexport,
    profile,
    collections,
    families,
    variants,
    articles,
    assignvariants,
    duplicates,
    ordering,
    offices,
    tempJobs,
    works,
    roles,
    warehouse,
    dataimport,
    monitor,
    gt2000,
    saldatrice,
    babypressa,
    terminal,
    pdfexport,
    moldmapping,
    labeling,
} = routes

const disabledColor = 'rgba(255,99,71,.4)'
const estegomenu = [
    {
        key: collections,
        label: 'Collezioni',
        icon: 'object group',
        show: (user) => {
            return !!user.info_collections
        },
    },
    {
        key: families,
        label: 'Famiglie',
        icon: 'folder open',
        show: (user) => {
            return !!user.info_families
        },
    },
    {
        key: articles,
        label: 'Articoli',
        icon: 'images',
        show: (user) => {
            return !!user.info_articles
        },
    },
    {
        key: variants,
        label: 'Varianti',
        icon: 'file image',
        show: (user) => {
            return !!user.info_variants
        },
    },
    {
        key: assignvariants,
        label: 'Associazione varianti',
        icon: 'object group outline',
        show: (user) => {
            return !!user.info_variants
        },
    },
    {
        key: duplicates,
        label: 'Associazione duplicati',
        icon: 'copy',
        show: (user) => {
            return true
        },
    },
    {
        key: ordering,
        label: 'Ordinamento',
        icon: 'ordered list',
        show: (user) => {
            return !!user.manage_ordering
        },
    },
    {
        key: admin,
        label: 'Utenti',
        icon: 'user outline',
        show: (user) => {
            return !!user.info_user
        },
    },
    {
        key: offices,
        label: 'Punti vendita',
        icon: 'map',
        show: (user) => {
            return !!user.info_office
        },
    },
]

const workerSidebar = [
    {
        key: terminal,
        label: 'Produzione in tempo reale',
        icon: 'chart area',
        show: (user) => {
            return true
        },
    },
    {
        key: insertion,
        label: 'Inserimento ore lavoro',
        icon: 'tasks',
        disabled: true,
        show: (user) => {
            return true
        },
    },
    {
        key: calendarView,
        label: 'Calendario',
        icon: 'calendar alternate outline',
        disabled: true,
        show: (user) => {
            return true
        },
    },
    {
        key: labeling,
        label: 'Etichettatura',
        icon: 'sticky note',
        disabled: true,
        show: (user) => {
            return true
        },
    },
]

const vfmenu = [
    {
        key: jobs,
        label: 'Stampi',
        icon: 'tasks',
        show: (user) => {
            return !!user.info_job
        },
    },
    {
        key: tempJobs,
        label: 'Stampi da ricontrollare',
        icon: 'tag',
        show: (user) => {
            return !!user.info_temp_job
        },
    },
    {
        key: moldmapping,
        label: 'Mappatura interna',
        icon: 'sitemap',
        show: (user) => {
            return !!user.info_job
        },
    },
    {
        key: works,
        label: 'Lavori non assegnati',
        icon: 'hourglass outline',
        show: (user) => {
            return !!user.info_job
        },
    },
    {
        key: employees,
        label: 'Impiegati',
        icon: 'address card outline',
        show: (user) => {
            return !!user.info_worker
        },
    },
    {
        key: machines,
        label: 'Macchine',
        icon: 'hdd outline',
        show: (user) => {
            return !!user.info_machine
        },
    },
    {
        key: stock,
        label: 'Magazzino',
        icon: 'warehouse',
        show: (user) => {
            return !!user.info_stock
        },
    },
    {
        key: calendarView,
        label: 'Calendario',
        icon: 'calendar alternate outline',
        show: (user) => {
            return true
        },
    },
    {
        label: 'Dati',
        icon: 'chart area',
        show: (user) => {
            return true
        },
        menu: [
            {
                key: monitor,
                label: 'C.B. Ferrari',
                icon: 'chart line',
                show: (user) => {
                    return true
                },
            },
            {
                key: gt2000,
                label: 'C.B. Ferrari GT2000 Logs',
                icon: 'chart line',
                show: (user) => {
                    return true
                },
            },
            {
                key: saldatrice,
                label: 'SWA300',
                icon: 'chart line',
                show: (user) => {
                    return true
                },
            },
            {
                key: babypressa,
                label: 'Baby Pressa',
                icon: 'chart line',
                show: (user) => {
                    return true
                },
            },
        ],
    },
    {
        label: 'Altro',
        icon: 'box',
        show: () => true,
        menu: [
            {
                key: dataimport,
                label: 'Importazione dati',
                icon: 'upload',
                show: (user) => {
                    return !!user.data_import
                },
            },
            {
                key: pdfexport,
                label: 'Esportazione PDF',
                icon: 'download',
                show: (user) => {
                    return true
                },
            },
        ],
    },
    {
        label: 'Gestione utenti',
        icon: 'user outline',
        show: (user) => {
            return !!user.info_user
        },
        menu: [
            {
                key: admin,
                label: 'Utenti',
                icon: 'user outline',
                show: (user) => {
                    return !!user.info_user
                },
            },
            {
                key: employees,
                label: 'Impiegati',
                icon: 'address card outline',
                show: (user) => {
                    return !!user.info_worker
                },
            },
        ],
    },
]

const normalmenu = [
    {
        key: dashboard,
        label: 'Home',
        icon: 'home',
        show: (user) => {
            return true
        },
    },
    {
        label: 'Commesse',
        key: jobs,
        icon: 'tasks',
        show: (user) => {
            return !!user.info_job
        },
        menu: [
            // {
            //     key: works,
            //     label: 'Lavori non assegnati',
            //     icon: 'hourglass outline',
            //     show: (user) => {
            //         return !!user.info_job
            //     },
            // },
            {
                key: tempJobs,
                label: 'Esterne',
                icon: 'tag',
                disabled: true,
                show: (user) => {
                    return !!user.info_temp_job
                },
            },
        ],
    },
    {
        key: machines,
        label: 'Macchine',
        icon: 'hdd outline',
        show: (user) => {
            return !!user.info_machine
        },
    },
    {
        key: employees,
        label: 'Impiegati',
        icon: 'address card outline',
        show: (user) => {
            return !!user.info_worker
        },
    },
    {
        label: 'Utenti',
        key: admin,
        icon: 'user outline',
        show: (user) => {
            return !!user.info_user
        },
        menu: [
            {
                key: roles,
                label: 'Permessi',
                icon: 'lock',
                disabled: true,
                show: (user) => {
                    return !!user.info_roles
                },
            },
        ],
    },
    {
        label: 'Magazzino',
        key: stock,
        icon: 'warehouse',
        show: () => true,
        menu: [
            // {
            //     key: warehouse,
            //     label: 'Magazzino elettronico',
            //     icon: 'warehouse',
            //     show: (user) => {
            //         return !!user.info_stock
            //     },
            // },
            {
                key: deposits,
                label: 'Depositi',
                icon: 'home',
                show: (user) => {
                    return !!user.info_deposit
                },
            },
            {
                key: documents,
                label: 'Storico',
                icon: 'book',
                show: (user) => {
                    return !!user.info_document
                },
            },
            {
                key: products,
                label: 'Articoli',
                icon: 'shopping cart',
                show: (user) => {
                    return !!user.info_product
                },
            },
            {
                key: categories,
                label: 'Categorie',
                icon: 'picture',
                show: (user) => {
                    return !!user.info_category
                },
            },
            {
                key: corps,
                label: 'Tipologie',
                icon: 'object group outline',
                show: (user) => {
                    return !!user.info_corp
                },
            },
            // {
            //     label: 'More',
            //     dropdown: true,
            //     show: () => true,
            //     menu: [

            //         {
            //             key: collections,
            //             label: 'Collezioni',
            //             icon: 'object group',
            //             disabled: true,
            //             show: (user) => {
            //                 return !!user.info_collections
            //             },
            //         },
            //         {
            //             key: families,
            //             label: 'Famiglie',
            //             icon: 'folder open',
            //             disabled: true,
            //             show: (user) => {
            //                 return !!user.info_families
            //             },
            //         },
            //         {
            //             key: articles,
            //             label: 'Articoli Vetr.',
            //             icon: 'images',
            //             disabled: true,
            //             show: (user) => {
            //                 return !!user.info_articles
            //             },
            //         },
            //         {
            //             key: variants,
            //             label: 'Varianti',
            //             icon: 'file image',
            //             disabled: true,
            //             show: (user) => {
            //                 return !!user.info_variants
            //             },
            //         },
            //         {
            //             key: assignvariants,
            //             label: 'Associa',
            //             icon: 'object group outline',
            //             disabled: true,
            //             show: (user) => {
            //                 return !!user.info_variants
            //             },
            //         },
            //         {
            //             key: duplicates,
            //             label: 'Duplicati',
            //             icon: 'copy',
            //             disabled: true,
            //             show: (user) => {
            //                 return true
            //             },
            //         },
            //         {
            //             key: offices,
            //             label: 'Punti vendita Vetr.',
            //             icon: 'map',
            //             disabled: true,
            //             show: (user) => {
            //                 return !!user.info_office
            //             },
            //         },
            //     ],
            // },
        ],
    },
    {
        label: 'Vetrina',
        icon: 'grid layout',
        disabled: true,
        show: () => true,
        menu: [
            {
                key: ordering,
                label: 'Ordina',
                icon: 'ordered list',
                disabled: true,
                show: (user) => {
                    return !!user.manage_ordering
                },
            },
        ],
    },
    // {
    //     label: 'Altro',
    //     icon: 'box',
    //     disabled: true,
    //     show: () => true,
    //     menu: [
    //         {
    //             key: dataexport,
    //             label: 'Esportazione',
    //             icon: 'download',
    //             disabled: true,
    //             show: (user) => {
    //                 return !!user.data_export
    //             },
    //         },
    //         {
    //             key: dataimport,
    //             label: 'Importazione',
    //             icon: 'upload',
    //             disabled: true,
    //             show: (user) => {
    //                 return !!user.data_import
    //             },
    //         },
    //         {
    //             key: 'download_pdf',
    //             label: 'Documentazione',
    //             icon: 'cloud download',
    //             disabled: true,
    //             show: (user) => {
    //                 return !!user.download_pdf
    //             },
    //             action: () => window.open(process.env.PUBLIC_URL + '/RichiestaDigitalArtisan.pdf'),
    //         },
    //     ],
    // },
    /*
	{
		key: turns,
		label: 'Turni di lavoro',
		icon: 'time',
		show: (user) => {
			return !!user.settings
		}
	},
	{
		key: settings,
		label: 'Blackbox e license',
		icon: 'cogs',
		show: (user) => {
			return !!user.settings
		}
	},
	{
		key: help,
		label: 'Help',
		icon: 'question circle outline',
		show: (user) => {
			return !!user.help
		}
	},
	{
		key: about,
		label: 'Informazioni',
		icon: 'info',
		show: (user) => {
			return !!user.about
		}
	},
	*/
]

const menu = normalmenu
const workermenu = workerSidebar

class SideBar extends Component {
    constructor(props) {
        super(props)
        let {
            location: { pathname },
        } = this.props.history
        let { history, isEmployee, isDateSidebar, login, workday } = this.props

        //set profile page
        let { data = {} } = login
        let { user = {} } = data
        let { companies = [] } = user
        let organizationId = companies[0]

        if (organizationId) {
            let profileIndex = menu.findIndex((x) => x.key === profile)
            if (profileIndex >= 0) menu[profileIndex].key = route_from(profile, `${organizationId}`)
        }

        this.state = {
            sidemenu: get_section(pathname),
            weekStart: moment().subtract(7, 'days'),
            weekEnd: moment(),
            selected: {},
            hideSidebar: false,
            menuToShow: props.isEmployee ? workermenu : menu,
        }

        if (isDateSidebar) {
            let m = workday.data.date
            let value = {
                date: m,
                color: m.day() === 0 || m.day() === 6 ? 'red' : 'grey',
                key: m.format('YYYY-MM-DD'),
            }
            this.props.workdayResult(value)
            this.state.sidemenu = value.key
            this.state.selected = value
        }

        if (this.checkPath(pathname) && isDateSidebar) {
            this.state.hideSidebar = true
        }

        this.unlisten = history.listen((location) => {
            let { pathname } = location
            if (this.checkPath(pathname) && isDateSidebar) {
                this.setState({
                    hideSidebar: true,
                })
            } else {
                this.setState({
                    hideSidebar: false,
                })
            }
        })
    }

    checkPath(pathname) {
        return pathname === route_from(employee, insertion, calendarView) || pathname === route_from(employee, calendarView)
    }

    nextWeek() {
        this.setState({
            weekStart: this.state.weekStart.add(1, 'w'),
            weekEnd: this.state.weekEnd.add(1, 'w'),
        })
    }

    prevWeek() {
        this.setState({
            weekStart: this.state.weekStart.subtract(1, 'w'),
            weekEnd: this.state.weekEnd.subtract(1, 'w'),
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let { workday } = this.props

        if (workday !== prevProps.workday) {
            this.setState({
                weekStart: moment(workday.data.date).startOf('week'),
                weekEnd: moment(workday.data.date).endOf('week'),
                selected: moment(workday.data.date).format('YYYY-MM-DD'),
                sidemenu: workday.data.key,
            })
        }
    }

    renderMenu(_menu, submenu, parentDropdown) {
        let { sidemenu, hideSidebar } = this.state
        let { history, isEmployee, isDateSidebar, login } = this.props
        const MenuContainer = submenu ? Menu.Menu : Menu
        if (isDateSidebar) {
            let days = []
            for (var m = moment(this.state.weekStart); m.isBefore(this.state.weekEnd); m.add(1, 'days')) {
                days.push({
                    date: moment(m),
                    color: m.day() === 0 || m.day() === 6 ? 'red' : 'grey',
                    key: moment(m).format('YYYY-MM-DD'),
                    show: () => true,
                })
            }
            _menu = days
        }

        if (hideSidebar) {
            return null
        }

        let user = null
        if (!isEmployee && login && (login.fetching || !login.authenticated)) {
            return null
        } else if (login && login.authenticated) {
            user = login.data.user
        }

        let extraMenuProps = {}

        if (submenu) {
            extraMenuProps = {}
        } else {
            extraMenuProps = {}
        }

        return (
            <React.Fragment>
                <Default>
                    <MenuContainer
                        {...extraMenuProps}
                        className="noScrollBars sidebarContainer"
                        icon="labeled"
                        vertical={true}
                        borderless={true}
                        style={
                            !submenu
                                ? {
                                      zIndex: 45,
                                      borderRadius: 'unset',
                                      border: 'unset',
                                      boxShadow: 'unset',
                                      maxHeight: '98%',
                                      width: 100,
                                      overflowY: 'auto',
                                  }
                                : {}
                        }
                    >
                        {!submenu && !isDateSidebar && <Menu.Item style={{ height: 100 }} />}
                        {!submenu && isDateSidebar && (
                            <View row fullw around>
                                <Button
                                    onClick={() => {
                                        this.prevWeek()
                                    }}
                                >
                                    <Icon name="arrow left" />
                                </Button>
                                <Button
                                    onClick={() => {
                                        this.nextWeek()
                                    }}
                                >
                                    <Icon name="arrow right" />
                                </Button>
                            </View>
                        )}

                        {_menu.map((value, index) => {
                            let onClick = () => {}
                            if (value.key) {
                                onClick = (e) => {
                                    e.stopPropagation()
                                    e.nativeEvent.stopImmediatePropagation()

                                    if (value.disabled) return this.setState({ upgrade: true })
                                    if (value.action) return value.action()

                                    this.setState({ sidemenu: value.key, selected: value })
                                    if (!isEmployee && !isDateSidebar) {
                                        history.push(route_from(app, value.key))
                                    } else if (isDateSidebar) {
                                        this.props.workdayResult(value)
                                    } else {
                                        history.push(route_from(employee, value.key))
                                    }
                                }
                            }

                            if (value.show(user) && value.dropdown) {
                                return (
                                    <Dropdown key={index} item text={value.label}>
                                        <Dropdown.Menu>
                                            {value.menu &&
                                                value.menu.map((item, idx) => {
                                                    //TODO refactor
                                                    if (item.key) {
                                                        onClick = () => {
                                                            if (item.disabled) return this.setState({ upgrade: true })
                                                            if (item.action) return item.action()

                                                            this.setState({ sidemenu: item.key, selected: item })
                                                            if (!isEmployee && !isDateSidebar) {
                                                                history.push(route_from(app, item.key))
                                                            } else if (isDateSidebar) {
                                                                this.props.workdayResult(item)
                                                            } else {
                                                                history.push(route_from(employee, item.key))
                                                            }
                                                        }
                                                    }
                                                    return (
                                                        <Dropdown.Item
                                                            key={idx}
                                                            as="div"
                                                            icon={<Icon name={item.icon} style={item.disabled && { color: disabledColor }}></Icon>}
                                                            text={<span style={item.disabled && { color: disabledColor }}>{item.label}</span>}
                                                            onClick={onClick}
                                                        />
                                                    )
                                                })}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                )
                            }

                            return value.show(user) ? (
                                <Menu.Item
                                    key={index}
                                    style={{
                                        ...(value.disabled ? { color: disabledColor } : {}),
                                        ...(!submenu
                                            ? {
                                                  padding: '8px',
                                                  borderBottom: '1px solid black',
                                              }
                                            : { marginLeft: 6 }),
                                    }}
                                    name={`${value.key}`}
                                    active={value.key === sidemenu}
                                    onClick={onClick}
                                >
                                    {isDateSidebar && (
                                        <Statistic color={value.color}>
                                            <Statistic.Value>{value.date.format('DD')}</Statistic.Value>
                                            <Statistic.Label>
                                                {value.date.format('MM')}/{value.date.format('YYYY')}
                                            </Statistic.Label>
                                        </Statistic>
                                    )}
                                    {!isDateSidebar && !submenu && (
                                        <React.Fragment>
                                            <Icon name={value.icon} />
                                            {value.label}
                                        </React.Fragment>
                                    )}
                                    {!isDateSidebar && submenu && (
                                        <View fullw row>
                                            <Icon style={value.disabled && { color: disabledColor }} name={value.icon} />
                                            <span style={value.disabled && { color: disabledColor }}>{value.label}</span>
                                        </View>
                                    )}
                                    {value.menu ? this.renderMenu(value.menu, true) : null}
                                </Menu.Item>
                            ) : null
                        })}
                    </MenuContainer>
                </Default>

                <Mobile>
                    {_menu.map((value, index) => {
                        if (!value.show(user)) return null

                        let onClick = () => {}
                        if (value.key) {
                            onClick = () => {
                                if (value.action) return value.action()

                                this.setState({ sidemenu: value.key, selected: value })
                                if (!isDateSidebar) {
                                    history.push(route_from(app, value.key))
                                } else {
                                    this.props.workdayResult(value)
                                }
                            }
                        }

                        if (value.menu) return this.renderMenu(value.menu)

                        return (
                            <Menu.Item key={index} name={`${value.key}`} active={value.key === sidemenu} onClick={onClick}>
                                {isDateSidebar && (
                                    <Statistic color={value.color}>
                                        <Statistic.Value>{value.date.format('DD')}</Statistic.Value>
                                        <Statistic.Label>
                                            {value.date.format('MM')}/{value.date.format('YYYY')}
                                        </Statistic.Label>
                                    </Statistic>
                                )}
                                {!isDateSidebar && (
                                    <React.Fragment>
                                        <Icon name={value.icon} />
                                        {value.label}
                                    </React.Fragment>
                                )}
                            </Menu.Item>
                        )
                    })}
                </Mobile>
            </React.Fragment>
        )
    }

    renderStandardVersion() {
        return (
            <span
                style={{
                    zIndex: 100,
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    fontFamily: 'monospace',
                    background: '#000000',
                    color: '#FFD90F',
                    fontWeight: 'bold',
                    width: '92px',
                    textAlign: 'center',
                }}
            >
                {`${process.env.REACT_APP_VERSION}`}
            </span>
        )
    }

    renderVfVersion() {
        return (
            <span
                style={{
                    zIndex: 100,
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    fontFamily: 'monospace',
                    background: '#014493',
                    color: '#FFFFFF',
                    fontWeight: 'bold',
                    width: '110px',
                    textAlign: 'center',
                }}
            >
                {`${process.env.REACT_APP_VERSION}`}
            </span>
        )
    }

    render() {
        let { isEmployee, isDateSidebar } = this.props
        let _menu = this.state.menuToShow
        return (
            <React.Fragment>
                <Default>
                    {this.renderMenu(_menu)}
                    {process.env.REACT_APP_BRANDING === 'syncode' ? this.renderStandardVersion() : null}
                    {process.env.REACT_APP_BRANDING === 'vfstampi' ? this.renderVfVersion() : null}
                </Default>
                <Mobile>
                    <Menu
                        icon="labeled"
                        style={{
                            zIndex: 45,
                            borderRadius: 'unset',
                            border: 'unset',
                            boxShadow: 'unset',
                            maxWidth: '100%',
                        }}
                    >
                        {isDateSidebar && (
                            <View column around>
                                <Button
                                    onClick={() => {
                                        this.prevWeek()
                                    }}
                                >
                                    <Icon name="arrow left" />
                                </Button>
                                <Button
                                    onClick={() => {
                                        this.nextWeek()
                                    }}
                                >
                                    <Icon name="arrow right" />
                                </Button>
                            </View>
                        )}
                        {this.renderMenu(_menu)}
                    </Menu>
                </Mobile>
                <Modal closeIcon dimmer={'blurring'} open={this.state.upgrade} onClose={() => this.setState({ upgrade: false })}>
                    <Modal.Header>Modulo non ancora disponibile</Modal.Header>
                    <Modal.Content image>
                        <Image
                            wrapped
                            size="small"
                            src="data:image/jpeg;base64,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"
                        />
                        <Modal.Description>
                            <Header>Presto i moduli aggiuntivi saranno abilitati!</Header>
                            <p>Contattaci se desideri avere più informazioni a riguardo</p>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            positive
                            icon="checkmark"
                            labelPosition="right"
                            content="Contattaci"
                            onClick={() => {
                                window.location.href = 'mailto:info@syncode.it'
                                this.setState({ upgrade: false })
                            }}
                        />
                    </Modal.Actions>
                </Modal>
            </React.Fragment>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        workdayRequest: (result) => WORKDAY_ACTIONS.request(result, dispatch),
        workdayResult: (result) => WORKDAY_ACTIONS.result(result, dispatch),
        workdayError: (result) => WORKDAY_ACTIONS.error(result, dispatch),
    }
}

const mapStateToProps = (state) => {
    let { workday, login } = state

    return {
        workday,
        login,
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(connectNetwork(SideBar)))
